export default __webpack_public_path__ + "static/media/delilah.050ff2dc.PNG";